import React from 'react';

const StockmarketSVG = () => (
  <svg width="480.002" height="480.002" xmlns="http://www.w3.org/2000/svg">
    <g>
      <title>Layer 1</title>
      <g id="svg_34">
        <g id="svg_1">
          <g id="svg_2">
            <path
              id="svg_3"
              d="m148.44839,239.37981c-0.00058,0 -0.00177,0 -0.00235,0l-37.68889,0c-2.60112,-0.00061 -4.71053,2.1076 -4.71111,4.70874c0,0.00061 0,0.00177 0,0.00238l0,80.08888c-0.0006,2.60114 2.10762,4.71051 4.70876,4.71112c0.00058,0 0.00175,0 0.00235,0l37.68889,0c2.60112,0.00061 4.71053,-2.10767 4.71111,-4.70874c0,-0.00061 0,-0.00177 0,-0.00238l0,-80.08888c0.0006,-2.60114 -2.10764,-4.71057 -4.70876,-4.71112zm-4.71405,80.08888l-28.26666,0l0,-70.6667l28.26666,0l0,70.6667z"
            />
          </g>
        </g>
        <g id="svg_4">
          <g id="svg_5">
            <path
              id="svg_6"
              d="m318.0484,201.69092c-0.00058,0 -0.00177,0 -0.00235,0l-37.6889,0c-2.6011,-0.00061 -4.71051,2.10764 -4.71109,4.70874c0,0.00061 0,0.00177 0,0.00235l0,117.7778c-0.00061,2.60114 2.10764,4.71051 4.70874,4.71112c0.00061,0 0.00177,0 0.00235,0l37.6889,0c2.6011,0.00061 4.71051,-2.10767 4.71112,-4.70874c0,-0.00061 0,-0.00177 0,-0.00238l0,-117.7778c0.00058,-2.60114 -2.10764,-4.71054 -4.70877,-4.71109zm-4.71405,117.77777l-28.26666,0l0,-108.35556l28.26666,0l0,108.35556z"
            />
          </g>
        </g>
        <g id="svg_7">
          <g id="svg_8">
            <path
              id="svg_9"
              d="m261.51508,225.24644c-0.00061,0 -0.00177,0 -0.00235,0l-37.6889,0c-2.6011,-0.00055 -4.71051,2.10767 -4.71109,4.7088c0,0.00055 0,0.00171 0,0.00232l0,94.22224c-0.00061,2.60114 2.1076,4.71051 4.70874,4.71112c0.00058,0 0.00177,0 0.00235,0l37.6889,0c2.6011,0.00061 4.71051,-2.10767 4.71109,-4.70874c0,-0.00061 0,-0.00177 0,-0.00238l0,-94.22224c0.00058,-2.60114 -2.10764,-4.71051 -4.70874,-4.71112zm-4.71405,94.22224l-28.26669,0l0,-84.8l28.26669,0l0,84.8z"
            />
          </g>
        </g>
        <g id="svg_10">
          <g id="svg_11">
            <path
              id="svg_12"
              d="m204.98172,168.7131c-0.00058,0 -0.00174,0 -0.00235,0l-37.68887,0c-2.60114,-0.00058 -4.71054,2.10764 -4.71112,4.70877c0,0.00058 0,0.00177 0,0.00235l0,150.75558c-0.00058,2.60114 2.10764,4.71051 4.70877,4.71112c0.00058,0 0.00174,0 0.00235,0l37.68887,0c2.60114,0.00055 4.71054,-2.10767 4.71112,-4.70874c0,-0.00061 0,-0.00183 0,-0.00238l0,-150.75558c0.00058,-2.6011 -2.10764,-4.71051 -4.70877,-4.71112zm-4.71405,150.75558l-28.26666,0l0,-141.33334l28.26666,0l0,141.33334z"
            />
          </g>
        </g>
        <g id="svg_13">
          <g id="svg_14">
            <path
              id="svg_15"
              d="m374.58173,262.93536c-0.00058,0 -0.00174,0 -0.00235,0l-37.68887,0c-2.60114,-0.00061 -4.71054,2.10767 -4.71112,4.70874c0,0.00061 0,0.00177 0,0.00238l0,56.53333c-0.00058,2.60114 2.10764,4.71051 4.70877,4.71112c0.00058,0 0.00174,0 0.00235,0l37.68887,0c2.60114,0.00061 4.71051,-2.10767 4.71112,-4.70874c0,-0.00061 0,-0.00177 0,-0.00238l0,-56.53333c0.00058,-2.60114 -2.10764,-4.71057 -4.70877,-4.71112zm-4.71405,56.53333l-28.26666,0l0,-47.11108l28.26666,0l0,47.11108z"
            />
          </g>
        </g>
        <g id="svg_16">
          <g id="svg_17">
            <path
              id="svg_18"
              d="m382.86798,149.4971c-0.29797,-0.34805 -0.64542,-0.65073 -1.03116,-0.89807l-18.84442,-12.11343c-2.18655,-1.40744 -5.10037,-0.77618 -6.50842,1.41037c-0.48935,0.76086 -0.74963,1.64597 -0.74963,2.55048l0,9.42224l-16.32339,0l-36.29028,-54.43571c-1.61417,-2.16476 -4.67755,-2.61115 -6.84232,-0.99699c-0.37866,0.28267 -0.7149,0.61833 -0.99698,0.99699l-51.70917,77.56313l-53.10834,-123.91458c-0.73669,-1.76843 -2.48337,-2.90321 -4.39841,-2.85728c-1.91095,0.0265 -3.6152,1.20663 -4.31305,2.98567l-60.06902,152.48102l-20.34904,0l0,9.42221l23.55554,0c1.93568,0.00058 3.67467,-1.18427 4.38193,-2.98569l57.04626,-144.80246l52.02008,121.37527c1.02173,2.39148 3.78833,3.50156 6.17981,2.47983c0.84268,-0.3598 1.56174,-0.95813 2.06934,-1.72073l52.61371,-78.92053l33.76923,50.65387c0.87332,1.31085 2.34436,2.09821 3.91965,2.09763l18.84445,0l0,9.42221c-0.00058,2.6011 2.10706,4.71051 4.70816,4.71112c1.12595,0.00058 2.21481,-0.4028 3.06931,-1.13657l18.84442,-16.15323c1.97455,-1.69067 2.20364,-4.66281 0.51175,-6.63675zm-17.71143,8.97525l0,-9.39456l6.26401,4.02563l-6.26401,5.36893z"
            />
          </g>
        </g>
        <g id="svg_19" />
        <g id="svg_20" />
        <g id="svg_21" />
        <g id="svg_22" />
        <g id="svg_23" />
        <g id="svg_24" />
        <g id="svg_25" />
        <g id="svg_26" />
        <g id="svg_27" />
        <g id="svg_28" />
        <g id="svg_29" />
        <g id="svg_30" />
        <g id="svg_31" />
        <g id="svg_32" />
        <g id="svg_33" />
      </g>
    </g>
  </svg>
);

export default StockmarketSVG;
